/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';

@Injectable()
export abstract class AmplitudeAbstractService {
  abstract init(): void;

  abstract setItem(key: string, val: any): void;

  abstract setItems(list: Array<{ key: string; val: any }>): void;

  abstract unsetItem(key: string): void;

  abstract logEventWithTimestamp(name: string, data: any): void;

  abstract logEvent(
    name: string,
    data: Record<string, unknown>,
    onSuccess: () => void,
    onError: (message?: string) => void,
  ): void;
}
